<qrcode class="qrcode" [elementType]="elementType" [errorCorrectionLevel]="level" [qrdata]="qrdata" [scale]="scale" colorLight="#00000000"></qrcode>
